/* Mayberry-style card variant thumbnail hover-swap. v2026-05-30b
   External file = Shopify auto-versions the URL → browsers MUST fetch
   the latest on each deploy (no inline-in-cached-HTML stale-state).
   One delegated listener for the entire page, attached once. */
(function () {
  if (window.__mbCardThumbsExt) return;
  window.__mbCardThumbsExt = true;

  /* Strip srcset/sizes from ALL card images at page load time, so even
     before the user hovers anything, the browser uses src directly.
     This is the bullet-proof fix: never let srcset interfere. */
  function mbStripAllSrcsets() {
    var imgs = document.querySelectorAll('.card-wrapper .card__media img, .card .card__media img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].removeAttribute('srcset');
      imgs[i].removeAttribute('sizes');
    }
    var sources = document.querySelectorAll('.card-wrapper .card__media source, .card .card__media source');
    for (var j = 0; j < sources.length; j++) {
      sources[j].removeAttribute('srcset');
    }
  }
  if (document.readyState !== 'loading') mbStripAllSrcsets();
  else document.addEventListener('DOMContentLoaded', mbStripAllSrcsets);
  setTimeout(mbStripAllSrcsets, 800);
  setTimeout(mbStripAllSrcsets, 2500);

  function mbSelectThumb(thumb) {
    var wrapper = thumb.closest('.card-wrapper') || thumb.closest('.card');
    if (!wrapper) return;
    var media = wrapper.querySelector('.card__media');
    if (!media) return;
    var newSrc = thumb.getAttribute('data-mb-thumb');
    if (newSrc) {
      /* <picture> <source> elements take priority over <img> — REMOVE
         their srcset entirely so the browser falls through to <img>. */
      var sources = media.querySelectorAll('source');
      for (var s = 0; s < sources.length; s++) {
        sources[s].removeAttribute('srcset');
      }
      /* Strip srcset + sizes from every img so browser uses src only,
         then assign new src. Without this, srcset's responsive picks
         override the src change and the image visually never updates. */
      var imgs = media.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].removeAttribute('srcset');
        imgs[k].removeAttribute('sizes');
        imgs[k].src = newSrc;
      }
    }
    var sibs = wrapper.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
    thumb.classList.add('is-active');
  }

  function mbPreload(wrap) {
    if (!wrap || wrap.__mbPreloaded) return;
    wrap.__mbPreloaded = true;
    var ts = wrap.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < ts.length; i++) {
      var s = ts[i].getAttribute('data-mb-thumb');
      if (s) { var im = new Image(); im.src = s; }
    }
  }

  /* Mouseover: instant preview + preload variants. */
  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    mbPreload(e.target.closest('.card-wrapper') || e.target.closest('.card'));
    var thumb = e.target.closest('.mb-card__thumb');
    if (thumb) mbSelectThumb(thumb);
  }, { passive: true });

  /* Click handling:
     - thumbnail → select variant (no navigate)
     - card image → navigate to the product page (we disabled Dawn's
       card-wide overlay link so thumbs get hover, so re-add image-click
       navigation here). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var thumb = e.target.closest('.mb-card__thumb');
    if (thumb) {
      /* Thumb tap/click = swap the card's MAIN image to this variant —
         never navigate (preventDefault cancels the anchor; stopPropagation
         keeps it off the card-wide product link). On touch the synthesized
         mouseover already swapped, so the swap here is idempotent. */
      e.preventDefault();
      e.stopPropagation();
      mbSelectThumb(thumb);
      return;
    }
    /* image / media click → go to product (ignore real links/buttons) */
    var media = e.target.closest('.card__media');
    if (!media) return;
    if (e.target.closest('a, button')) return; /* let genuine links work */
    var wrapper = media.closest('.card-wrapper') || media.closest('.card');
    if (!wrapper) return;
    var link = wrapper.querySelector('a[href*="/products/"]') ||
               wrapper.querySelector('.card__heading a, .full-unstyled-link');
    if (link && link.getAttribute('href')) {
      window.location.href = link.getAttribute('href');
    }
  });

  /* Scrub across the photo to cycle variants. */
  document.addEventListener('mousemove', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media) return;
    var wrapper = media.closest('.card-wrapper') || media.closest('.card');
    if (!wrapper) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs.length < 2) return;
    var rect = media.getBoundingClientRect();
    var frac = (e.clientX - rect.left) / rect.width;
    if (frac < 0) frac = 0;
    if (frac > 0.999) frac = 0.999;
    var idx = Math.floor(frac * thumbs.length);
    var target = thumbs[idx];
    if (target && !target.classList.contains('is-active')) mbSelectThumb(target);
  }, { passive: true });

  /* Revert to first variant on card-leave. */
  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest && e.target.closest('.card-wrapper');
    if (!wrapper) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs[0]) mbSelectThumb(thumbs[0]);
  }, { passive: true });

  /* Move .card__badge (Sale/Sold-out) into .card__media so absolute
     positioning anchors to the image, not the info-area below. */
  function mbRelocateBadges() {
    var cards = document.querySelectorAll('.card-wrapper, .card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var badge = card.querySelector('.card__badge');
      var media = card.querySelector('.card__media');
      if (badge && media && badge.parentElement !== media) {
        media.appendChild(badge);
      }
    }
  }
  if (document.readyState !== 'loading') mbRelocateBadges();
  else document.addEventListener('DOMContentLoaded', mbRelocateBadges);
  setTimeout(mbRelocateBadges, 800);
  setTimeout(mbRelocateBadges, 2500);

  /* Eager preload of every card's variant photos DISABLED for PageSpeed — it
     loaded all cards' full variant images on every collection load. The swap
     now loads on demand; mbPreload still runs on hover (above), so an actively
     hovered card stays smooth. */
})();
